export default {
  BUSINESS_SUB: 'business_sub',
  EXPENSE_MGMT_SUB: 'expense_management_sub',
  GPR_SUB: 'gpr_sub'
};
